import HSCarousel from '@preline/carousel';

export function handleCarouselButtonClicks() {
    const hsCarouselUI = document.querySelectorAll('.ot-hs-carousel-ui');

    hsCarouselUI.forEach(ui => {
        ui.addEventListener("click", () => {
            const prevBtn = ui.querySelector(".hs-carousel-prev");
            const nextBtn = ui.querySelector(".hs-carousel-next");
            
            if (prevBtn?.classList.contains("disabled")) {
                prevBtn.setAttribute("disabled","");
            } else {
                prevBtn?.removeAttribute("disabled");
            }

            if (nextBtn?.classList.contains("disabled")) {
                nextBtn.setAttribute("disabled","");
            } else {
                nextBtn?.removeAttribute("disabled");
            }
        });
    });
}

export function prelineCarousel() {
    HSCarousel.autoInit();

    setTimeout(() => {
        document.querySelectorAll('[data-hs-carousel]').forEach((carouselElement) => {
            const carouselElementTyped = carouselElement as HTMLElement;
            const carousel = HSCarousel.getInstance(carouselElementTyped) as HSCarousel;

            const firstSlide = carouselElement.querySelector('.hs-carousel-slide');
            firstSlide?.classList.add('opacity-0');

            if (carousel?.el.classList.contains('js-hs-carousel-1')) {
                firstSlide?.querySelector('img')?.classList.add('opacity-0', 'translate-y-6');
                firstSlide?.querySelector('blockquote')?.classList.add('opacity-0', 'translate-y-6');
            }

            if (carousel?.el.classList.contains('js-hs-carousel-2')) {
                firstSlide?.querySelector('.ot-hs-carousel-content')?.classList.add('opacity-0', 'translate-y-6');
            }
        });
    }, 1000)
}
